import type { SVGProps } from 'react';
const SvgStub = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={120} height={100} fill="none" {...props}>
    <path
      fill="#D1D1D6"
      d="M83.258 25.296V0H36.742v25.296H0V100h120V25.296zM39.559 2.57h41.156v22.735H39.56zm77.604 94.592H2.827V56.316h55.75V62h2.837v-5.684h55.749zm.295-43.694H2.828V27.867h114.63z"
    />
  </svg>
);
export default SvgStub;
